import * as Footer from "./footerStyles";

export default function FooterContainer() {
  return (
    <Footer.Container>
        <Footer.Text>Developed by Rom Braveheart Leuterio</Footer.Text>
        {/* <Footer.Text>Inspired from Brittany Chiang's</Footer.Text> */}
    </Footer.Container>
  );
}
